"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCREEN_SMALL_MAX = exports.SCREEN_SMALL_MAX = 767;
var SCREEN_MEDIUM = exports.SCREEN_MEDIUM = 768;
var SCREEN_MEDIUM_MAX = exports.SCREEN_MEDIUM_MAX = 1023;
var SCREEN_LARGE = exports.SCREEN_LARGE = 1024;
var SCREEN_LARGE_MAX = exports.SCREEN_LARGE_MAX = 1199;
var SCREEN_WIDE = exports.SCREEN_WIDE = 1200;

var MIN_TABLET = exports.MIN_TABLET = "@media all and (min-width: " + SCREEN_MEDIUM + "px)";
var MAX_TABLET = exports.MAX_TABLET = "@media all and (max-width: " + SCREEN_MEDIUM_MAX + "px)";
var MOBILE_ONLY = exports.MOBILE_ONLY = "@media all and (max-width: " + SCREEN_SMALL_MAX + "px)";
var TABLET_ONLY = exports.TABLET_ONLY = "@media all and (min-width: " + SCREEN_MEDIUM + "px and max-width: " + SCREEN_MEDIUM_MAX + "px)";
var DESKTOP_ONLY = exports.DESKTOP_ONLY = "@media all and (min-width: " + SCREEN_LARGE + "px)";